// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"4944b0d1","130":"c3cbdcdb","142":"9691eea4","288":"6fd069c5","397":"ba98f5ff","498":"3107b253","703":"2acfb66e","739":"023d9383","787":"351e4d75","847":"f46d0e94","872":"5dd88e9b"}[chunkId] + ".chunk.js";
};